<div class="armado">
  <p class="ayuda">
    Arrastrá los botones entre pantallas. El orden dentro de cada una es la
    prioridad. Una pantalla vacía no se muestra en la app.
  </p>

  @if (sueltos.length) {
    <p class="ayuda warn">
      <mat-icon inline>warning</mat-icon>
      {{ sueltos.length }} botón(es) sin pantalla asignada: el vecino no los ve.
      Arrastralos a una pantalla.
    </p>
    <div
      cdkDropList
      [cdkDropListData]="sueltos"
      [cdkDropListConnectedTo]="[lista1, lista2, lista3]"
      class="dropzone sueltos"
    >
      @for (id of sueltos; track id) {
        <div class="chip" cdkDrag>
          <mat-icon cdkDragHandle>drag_indicator</mat-icon>
          {{ btnLabel(id) }}
        </div>
      }
    </div>
  }

  <div class="pantallas">
    <!-- PANTALLA 1 -->
    <div class="pantalla">
      <div class="pantalla-head">
        <span class="num">1</span>
        <div class="pantalla-titulo">
          <strong>Pantalla 1 · Principales</strong>
          <span class="sub">La que se abre al entrar</span>
        </div>
        <span class="cuenta">{{ idsPantalla1.length }}</span>
      </div>
      <div
        cdkDropList
        #lista1="cdkDropList"
        [cdkDropListData]="idsPantalla1"
        [cdkDropListConnectedTo]="[lista2, lista3]"
        (cdkDropListDropped)="drop($event)"
        class="dropzone"
      >
        @for (id of idsPantalla1; track id) {
          <div class="chip" cdkDrag>
            <mat-icon cdkDragHandle>drag_indicator</mat-icon>
            {{ btnLabel(id) }}
          </div>
        } @empty {
          <div class="vacio">
            Soltá botones acá: sin esto la categoría no muestra nada
          </div>
        }
      </div>
    </div>

    <!-- PANTALLA 2 -->
    <div class="pantalla">
      <div class="pantalla-head">
        <span class="num">2</span>
        <div class="pantalla-titulo">
          <strong>Pantalla 2 · Secundarios</strong>
          <span class="sub">Se llega con el boton Mas</span>
        </div>
        <span class="cuenta">{{ idsPantalla2.length }}</span>
      </div>
      <div
        cdkDropList
        #lista2="cdkDropList"
        [cdkDropListData]="idsPantalla2"
        [cdkDropListConnectedTo]="[lista1, lista3]"
        (cdkDropListDropped)="drop($event)"
        class="dropzone"
      >
        @for (id of idsPantalla2; track id) {
          <div class="chip" cdkDrag>
            <mat-icon cdkDragHandle>drag_indicator</mat-icon>
            {{ btnLabel(id) }}
          </div>
        } @empty {
          <div class="vacio">Opcional: vacía no se muestra</div>
        }
      </div>
    </div>

    <!-- PANTALLA 3 -->
    <div class="pantalla">
      <div class="pantalla-head">
        <span class="num">3</span>
        <div class="pantalla-titulo">
          <strong>Pantalla 3 · Otros</strong>
          <span class="sub">Destino de los botones Menu</span>
        </div>
        <span class="cuenta">{{ idsPantalla3.length }}</span>
      </div>
      <div
        cdkDropList
        #lista3="cdkDropList"
        [cdkDropListData]="idsPantalla3"
        [cdkDropListConnectedTo]="[lista1, lista2]"
        (cdkDropListDropped)="drop($event)"
        class="dropzone"
      >
        @for (id of idsPantalla3; track id) {
          <div class="chip" cdkDrag>
            <mat-icon cdkDragHandle>drag_indicator</mat-icon>
            {{ btnLabel(id) }}
          </div>
        } @empty {
          <div class="vacio">Opcional: vacía no se muestra</div>
        }
      </div>
    </div>
  </div>
</div>
